module.exports = __webpack_public_path__ + "static/media/filter_filled_icon.16931d54.png";